<template>
  <div id="product">
    <div class="header flex-between">
      <div class="header-text">
        <h1>会员报表</h1>
      </div>

      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="el-icon-notebook-2"
          @click="SelectdisplayitemDialog = true"
          >选择显示项</el-button
        >
        <el-button icon="el-icon-notebook-2" @click="conditionDialog = true"
          >展开隐藏条件</el-button
        >
        <el-button
          icon="el-icon-search"
          v-if="jurisdiction.search"
          @click="search()"
          >查询</el-button
        >
        <el-button icon="el-icon-delete" @click="eliminate()"
          >清除筛选条件</el-button
        >
        <el-button
          icon="iconfont icon-chakan1"
          v-if="jurisdiction.export"
          @click="exportShow = true"
          >导出</el-button
        >

        <el-button
          icon="el-icon-download"
          v-if="jurisdiction.export"
          @click="(downloadShow = true), getDownladList()"
          >下载</el-button
        >
      </div>
    </div>

    <el-card shadow="never" :body-style="bodyStyle">
      <div style="padding: 15px 0 0 15px">
        <el-form
          label-width="140px"
          :model="queryInfo"
          size="small"
          :inline="true"
        >
          <el-form-item label="卡号\电话号码\姓名">
            <el-input v-model="queryInfo.cmn"></el-input>
          </el-form-item>
          <el-form-item label="区域">
            <el-select
              style="width: 100%"
              multiple
              v-model="queryInfo.regionIds"
            >
              <el-option
                v-for="item in Regioncax"
                :key="item.id"
                :label="item.lable"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="注册日期">
            <el-date-picker
              v-model="dateValue"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="会员等级">
            <el-select style="width: 100%" multiple v-model="queryInfo.LevelID">
              <el-option
                v-for="item in checkbooksData"
                :key="item.levelID"
                :value="item.levelID"
                :label="item.levelName_cn"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
              v-model="dateValue1"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label-width="180px" label="是否是奥莱会员">
            <el-select v-model="queryInfo.regionKind" placeholder="请选择">
              <el-option label="是" value="1"> </el-option>
              <el-option label="否" value="0"> </el-option>
              <el-option label="全部" value=""> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card shadow="never" :body-style="bodyStyle">
      <div style="padding: 15px 0 0 15px">
        <el-form
          :model="queryInfo"
          size="small"
          :inline="true"
          label-position="top"
        >
          <el-col :span="3">
            <el-form-item label="总记录数">
              <el-input
                readonly
                :value="
                  statisticsData.cnt ? toThousands(statisticsData.cnt) : '0'
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="去年消费额">
              <el-input
                readonly
                :value="
                  statisticsData.PrevYearAmountSum
                    ? toThousands(statisticsData.PrevYearAmountSum)
                    : '0'
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="去年消费次数">
              <el-input
                readonly
                :value="
                  statisticsData.PrevYearSaleTimesSum
                    ? toThousands(statisticsData.PrevYearSaleTimesSum)
                    : '0'
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="今年消费额">
              <el-input
                readonly
                :value="
                  statisticsData.CurrYearAmountSum
                    ? toThousands(statisticsData.CurrYearAmountSum)
                    : '0'
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="今年消费次数">
              <el-input
                readonly
                :value="
                  statisticsData.CurrYearSaleTimesSum
                    ? toThousands(statisticsData.CurrYearSaleTimesSum)
                    : '0'
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="当前可用积分">
              <el-input
                readonly
                :value="
                  statisticsData.CurrAvailPointSum
                    ? toThousands(statisticsData.CurrAvailPointSum)
                    : '0'
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="今年累计积分">
              <el-input
                readonly
                :value="
                  statisticsData.CurrYearPointsSum
                    ? toThousands(statisticsData.CurrYearPointsSum)
                    : '0'
                "
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-form-item label="最近一年消费额">
              <el-input
                readonly
                :value="
                  statisticsData.LastYearAmountSum
                    ? toThousands(statisticsData.LastYearAmountSum)
                    : '0'
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </el-card>

    <div>
      <el-card shadow="never" class="card-center" style="margin-top: 10px">
        <el-table
          :key="key"
          height="380px"
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          v-loading="loading"
          v-el-table-infinite-scroll="load"
          infinite-scroll-disabled="onLoading"
        >
          <el-table-column type="index" width="55"></el-table-column>
          <el-table-column label width="60">
            <template slot-scope="scope">
              <div
                  class="ConponesName"
                  @click="getCurrentRow(scope.row)"
              >
              会员信息
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in formThead"
            :key="index"
            :label="item.titleName"
            :prop="item.fieldName"
          ></el-table-column>
        </el-table>
        <el-alert
          v-if="tableData.length >= total"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        ></el-alert>
      </el-card>
    </div>
    <!-- 筛选条件弹窗 -->
    <el-dialog
      append-to-body
      width="1200px"
      :visible.sync="conditionDialog"
      :close-on-click-modal="false"
    >
      <el-row>
        <el-col :span="12">
          <el-form
            :model="queryInfo"
            size="small"
            :inline="true"
            label-width="130px"
          >
            <el-form-item label="卡号">
              <el-input v-model="queryInfo.cardNo"></el-input>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="queryInfo.userName"></el-input>
            </el-form-item>
            <el-form-item label="电话号码">
              <el-input v-model="queryInfo.Mobile"></el-input>
            </el-form-item>
            <el-form-item label="维护区域">
              <el-select
                v-model="queryInfo.regionIds"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in Regioncax"
                  :key="item.id"
                  :label="item.lable"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="维护店">
              <el-col :span="16">
                <textarea rows="8" v-model="ServiceOrgName" readonly></textarea>
              </el-col>
              <el-col :span="8">
                <el-button
                  style="margin-left: 10px"
                  @click="
                    (outletVisible = true),
                      (flag = 1),
                      (shopId = queryInfo.shopIds)
                  "
                  >选择门店</el-button
                >
              </el-col>
            </el-form-item>
            <el-form-item label="维护人">
              <el-input v-model="queryInfo.ServiceEmpName"></el-input>
            </el-form-item>
            <el-form-item label="注册日期">
              <el-date-picker
                v-model="dateValue"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="省份">
              <el-input v-model="queryInfo.provinceName"></el-input>
              <!-- <el-select
                filterable
                style="width: 100%"
                @change="provinceChange"
                v-model="aa"
              >
                <el-option
                  v-for="item in provinceData"
                  :key="item.stateID"
                  :value="item.stateID"
                  :label="item.stateName_cn"
                ></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="城市">
              <el-input v-model="queryInfo.cityName"></el-input>
              <!-- <el-select v-model="bb" style="width: 100%" @focus="focus">
                <el-option
                  v-for="item in cityData"
                  :key="item.cityID"
                  :value="item.cityID"
                  :label="item.cityName_en"
                ></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="会员等级">
              <el-select
                style="width: 100%"
                multiple
                v-model="queryInfo.LevelID"
              >
                <el-option
                  v-for="item in checkbooksData"
                  :key="item.levelID"
                  :value="item.levelID"
                  :label="item.levelName_cn"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="生日">
              <el-date-picker
                v-model="dateValue2"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item> -->
            <el-form-item label="生日所在月份">
              <div class="flex-between">
                <el-select
                  style="width: 45%"
                  v-model="queryInfo.birthMonthStart"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in months"
                    :key="item"
                    :label="item + '月'"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-select
                  style="width: 45%"
                  v-model="queryInfo.birthMonthEnd"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in months"
                    :key="item"
                    :label="item + '月'"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="生日所在日期">
              <div class="flex-between">
                <el-select
                  style="width: 45%"
                  v-model="queryInfo.birthDateStart"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in days"
                    :key="item"
                    :label="item + '日'"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-select
                  style="width: 45%"
                  v-model="queryInfo.birthDateEnd"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in days"
                    :key="item"
                    :label="item + '日'"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="年龄">
              <div class="flex-between">
                <el-input v-model="queryInfo.ageMin"></el-input>
                <span style="margin: 0 1rem 0 1rem">到</span>
                <el-input v-model="queryInfo.ageMax"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="最近购买日">
              <el-date-picker
                v-model="dateValue3"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="会员TAG">
              <el-select
                v-model="queryInfo.tagIds"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in memberTagList"
                  :key="item.userDefineID"
                  :label="item.description_CN"
                  :value="item.userDefineID"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否商城VIP">
              <el-select v-model="queryInfo.isMillVIP" placeholder="请选择">
                <el-option value="" label="所有"></el-option>
                <el-option value="1" label="是"></el-option>

                <el-option value="0" label="否"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="非分配维护人">
              <el-select v-model="queryInfo.isServiceEmp" placeholder="请选择">
                <el-option value="" label="所有"></el-option>

                <el-option value="1" label="已分配"></el-option>

                <el-option value="0" label="未分配"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="会员活跃度">
              <el-select
                  v-model="queryInfo.activityLvlTagID"
                  multiple
                  placeholder="请选择"
              >
                <el-option
                    v-for="item in activityLevelList"
                    :key="item.userDefineID"
                    :label="item.description_CN"
                    :value="item.userDefineID"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="今年消费额">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.CurrYearAmountMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.CurrYearAmountMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="去年消费额">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.PrevYearAmountMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.PrevYearAmountMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="最近一年消费额">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.LastYearAmountMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.LastYearAmountMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="TOP1客单价">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.SheetTopAmt1Min"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.SheetTopAmt1Max"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="TOP2客单价">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.SheetTopAmt2Min"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.SheetTopAmt2Max"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="TOP3客单价">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.SheetTopAmt3Min"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.SheetTopAmt3Max"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>

            <!-- <el-form-item label="生日所在月份">
              <div class="flex-between">
                <el-select style="width: 45%" v-model="queryInfo.birthMonthStart" placeholder="请选择">
                  <el-option v-for="item in months" :key="item" :label="item + '月'" :value="item"> </el-option>
                </el-select>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-select style="width: 45%" v-model="queryInfo.birthMonthEnd" placeholder="请选择">
                  <el-option v-for="item in months" :key="item" :label="item + '月'" :value="item"> </el-option>
                </el-select>
              </div>
            </el-form-item>

            <el-form-item label="生日所在日期">
              <div class="flex-between">
                <el-select style="width: 45%" v-model="queryInfo.birthDateStart" placeholder="请选择">
                  <el-option v-for="item in days" :key="item" :label="item + '日'" :value="item"> </el-option>
                </el-select>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-select style="width: 45%" v-model="queryInfo.birthDateEnd" placeholder="请选择">
                  <el-option v-for="item in days" :key="item" :label="item + '日'" :value="item"> </el-option>
                </el-select>
              </div>
            </el-form-item> -->
          </el-form>
        </el-col>

        <el-col :span="12">
          <el-form
            :model="queryInfo"
            size="small"
            :inline="true"
            label-width="130px"
          >
            <el-form-item label="M期间消费金额">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.MonetaryMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.MonetaryMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="F期间消费次数">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.FrequencyMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.FrequencyMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="T期间的最大单">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.TMaxMoneyMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.TMaxMoneyMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="RMF标签">
              <div class="flex-between">
                <el-select
                  style="width: 100%"
                  multiple
                  v-model="queryInfo.saleTagID"
                >
                  <el-option
                    v-for="item in levelRmfList"
                    :key="item.sortIndex"
                    :value="item.sortIndex"
                    :label="item.description_CN"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="行业">
              <el-select
                style="width: 100%"
                multiple
                v-model="queryInfo.industryID"
              >
                <el-option
                  v-for="item in definedData"
                  :key="item.userDefineID"
                  :value="item.userDefineID"
                  :label="item.description_CN"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="当前是否保级">
              <div class="flex-between">
                <el-select
                  v-model="queryInfo.hasRelegation"
                  placeholder="请选择"
                >
                  <el-option value="" label="所有"></el-option>
                  <el-option value="1" label="是"></el-option>

                  <el-option value="0" label="否"> </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="保级日期">
              <el-date-picker
                v-model="protectionDate"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="当前可能降级级别">
              <div class="flex-between">
                <el-select
                  style="width: 100%"
                  multiple
                  v-model="queryInfo.canDegradeLvl"
                >
                  <el-option
                    v-for="item in checkbooksData"
                    :key="item.levelID"
                    :value="item.levelID"
                    :label="item.levelName_cn"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item label="当前可用积分">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.CurrAvailPointMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.CurrAvailPointMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="去年累计积分">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.PreYearPointsMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.PreYearPointsMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="今年累计积分">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.CurrYearPointsMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.CurrYearPointsMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="升级为VIC的时间">
              <el-date-picker
                v-model="dateValue4"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="升级为VIC的机构">
              <el-col :span="16">
                <textarea
                  rows="8"
                  v-model="FirstVipOrgName"
                  readonly
                ></textarea>
              </el-col>
              <el-col :span="8">
                <el-button
                  style="margin-left: 10px"
                  @click="
                    (outletVisible = true),
                      (flag = 2),
                      (shopId = queryInfo.UpdateLvlOrgIds)
                  "
                  >选择门店</el-button
                >
              </el-col>
            </el-form-item>
            <el-form-item label="升级为VIC的区域">
              <el-select
                v-model="queryInfo.UpdateLvlRegionIds"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in Regioncax"
                  :key="item.id"
                  :label="item.lable"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="最新升级日期">
              <el-date-picker
                v-model="dateValue5"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="最新升级机构">
              <el-col :span="16">
                <textarea rows="8" v-model="lastLvlOrgName" readonly></textarea>
              </el-col>
              <el-col :span="8">
                <el-button
                  style="margin-left: 10px"
                  @click="
                    (outletVisible = true),
                      (flag = 3),
                      (shopId = queryInfo.lastLvlOrgIds)
                  "
                  >选择门店</el-button
                >
              </el-col>
            </el-form-item>

            <el-form-item label="去年消费次数">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.PrevYearSaleTimesMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.PrevYearSaleTimesMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="今年消费次数">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.CurrYearSaleTimesMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.CurrYearSaleTimesMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="平均客单价">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.AvgSheetAmtMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.AvgSheetAmtMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="平均折扣">
              <div class="flex-between">
                <el-input
                  v-model="queryInfo.AvgDiscountMin"
                  style="width: 45%"
                ></el-input>
                <span style="margin: 0 0.3125rem 0 0.3125rem">到</span>
                <el-input
                  v-model="queryInfo.AvgDiscountMax"
                  style="width: 45%"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="title">
        <div class="dialogTitle">
          <span>条件</span>
          <div></div>
          <div>
            <el-button @click="search(), (conditionDialog = false)"
              >查 询</el-button
            >
            <el-button @click="eliminate(), (conditionDialog = false)"
              >清除查询条件</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 门店弹窗 -->
    <el-dialog
      append-to-body
      width="35%"
      :visible.sync="outletVisible"
      title="选择门店"
      class="store-modal"
    >
      <el-form size="mini" label-width="90px">
        <el-row v-for="(item, index) in StoreSelectionList" :key="index">
          <el-col :span="12" v-for="(myitem, myindex) in item" :key="myindex">
            <el-tree
              ref="tree"
              v-if="myitem != undefined"
              :data="[myitem]"
              show-checkbox
              node-key="ShopID"
              highlight-current
              default-expand-all
              :default-checked-keys="shopId"
              :props="defaultProps"
            >
            </el-tree>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="ComButtomStore">确 定</el-button>
        <el-button @click="outletVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 下载弹窗 -->
    <el-dialog
      append-to-body
      width="50%"
      :visible.sync="downloadShow"
      title="下载文件"
    >
      <el-table
        size="small"
        class="table-style"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="downloadData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <!-- v-loading="loading"
        v-el-table-infinite-scroll="load"
        infinite-scroll-disabled="onLoading" -->
        <el-table-column type="index" width="55"></el-table-column>
        <el-table-column
          prop="startTime"
          label="开始执行时间"
        ></el-table-column>

        <el-table-column prop="endTime" label="结束执行时间"></el-table-column>

        <el-table-column prop="fileName" label="文件名"></el-table-column>

        <el-table-column prop="isComplate" label="状态">
          <template slot-scope="scope">
            {{ scope.row.isComplate ? "完成" : "执行中" }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下载">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-download"
              v-if="scope.row.isComplate"
              @click="download(scope.row.downloadUrl)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 导出弹窗 -->
    <div class="exporttc">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="导出会员报表"
        :visible.sync="exportShow"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否确定
            <span style="color: #ff0000">导出</span>会员报表?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Export">确 定</el-button>
          <el-button @click="exportShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 选择显示列弹窗 -->
    <div>
      <el-dialog
        :close-on-click-modal="false"
        width="40%"
        title="显示项"
        :visible.sync="SelectdisplayitemDialog"
      >
        <el-row :gutter="20">
          <el-col
            v-for="(item, index) in Selectdisplayitem"
            :key="index"
            :span="6"
          >
            <el-checkbox-group
              @change="handleCheckedCitiesChange"
              v-model="Selectdisplayiteme"
            >
              <el-checkbox :label="item.ID">{{ item.titleName }}</el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Selectfinish">选择完成</el-button>
          <el-button @click="Restoredefault">恢复默认选项</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 会员信息 -->
    <el-dialog
        append-to-body
        width="90%"
        :visible.sync="customerInfoVisible"
        title="会员信息"
        class="store-modal"
    >
      <el-card shadow="never" class="NumberCardWidth">
        <el-tabs v-model="activeName" stretch>
          <el-tab-pane label="基础信息" name="first">
            <div style="padding: 0 50px">
              <el-form
                  size="small"
                  label-width="120px"
                  :label-position="labelPosition"
                  :model="MemberInformation"
              >
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="客户姓">
                      <el-input
                          readonly
                          v-model="MemberInformation.lastName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="客户名">
                      <el-input
                          readonly
                          v-model="MemberInformation.firstName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="会员等级">
                      <el-input
                          readonly
                          v-model="MemberInformation.levelNameCn"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="会员卡号">
                      <el-input
                          readonly
                          v-model="MemberInformation.cardNo"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="维护店">
                      <el-input
                          readonly
                          v-model="MemberInformation.serviceOrgCode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="当前维护人">
                      <el-input
                          readonly
                          v-model="MemberInformation.serviceEmpName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="性别">
                      <el-input
                          readonly
                          v-model="MemberInformation.gender"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="出生日期">
                      <el-date-picker
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.birthday"
                          type="date"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="移动电话">
                      <el-input
                          readonly
                          v-model="MemberInformation.mobile"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="电子邮件">
                      <el-input
                          readonly
                          v-model="MemberInformation.userEmail"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="电话">
                      <el-input
                          readonly
                          v-model="MemberInformation.telCode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="行业">
                      <el-input
                          readonly
                          v-model="MemberInformation.industryName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="国家或地区">
                      <el-input
                          readonly
                          v-model="MemberInformation.countryNameCn"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="省">
                      <el-input
                          readonly
                          v-model="MemberInformation.stateNameCn"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="市">
                      <el-input
                          readonly
                          v-model="MemberInformation.cityNameCn"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="通讯地址">
                      <el-input
                          readonly
                          v-model="MemberInformation.mailAddress"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="常住地址">
                      <el-input
                          readonly
                          v-model="MemberInformation.permanentAddress"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="小程序OpenID">
                      <el-input
                          readonly
                          v-model="MemberInformation.weChatOpenID"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="UnionID">
                      <el-input
                          readonly
                          v-model="MemberInformation.unionID"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-checkbox
                          disabled
                          v-model="MemberInformation.custType"
                          label="VIC会员"
                      ></el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="涉及业务">
                      <el-input
                          readonly
                          v-model="busskind"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="会员补充信息" name="second">
            <div style="padding: 0 50px">
              <el-form
                  size="small"
                  label-width="150px"
                  :label-position="labelPosition"
                  :model="MemberInformation"
              >
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="注册门店">
                      <el-input
                          readonly
                          v-model="MemberInformation.registOrgCode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="注册日期">
                      <el-date-picker
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.registDate"
                          type="date"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="最新升级门店">
                      <el-input
                          readonly
                          v-model="MemberInformation.updateLvlOrgCode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最新升级日期">
                      <el-date-picker
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.updateLvlDate"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="首次升级VIC门店">
                      <el-input
                          readonly
                          v-model="MemberInformation.firstVipOrgCode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="首次升级VIC日期">
                      <el-date-picker
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.firstVipDate"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="保级起始日期">
                      <el-date-picker
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.lvlStartDate"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="保级终止日期">
                      <el-date-picker
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.lvlExpireDate"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="当前保级消费总金额">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.lvlAmount"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="当前可能降级级别">
                      <el-input
                          readonly
                          v-model="MemberInformation.canDegradeName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="会员来源">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.custSourceName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-checkbox
                          name="type"
                          label="保级成功"
                          disabled
                          v-model="MemberInformation.hasRelegation"
                      ></el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="会员来源-备注">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.custSourceNotes"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-checkbox
                          disabled
                          v-model="MemberInformation.isMillVIP"
                          label="商场VIP"
                      ></el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="会员TAG">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.MemberTag"
                        ></textarea>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="推荐人">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.referrerName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="联系方式添加情况">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="checkBoxText.contactInfo"
                      ></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="积分信息" name="third">
            <div style="padding: 0 50px">
              <el-form
                  size="small"
                  label-width="160px"
                  :label-position="labelPosition"
                  :model="MemberInformation"
              >
                <el-row :gutter="200">
                  <el-col :span="24">
                    <el-form-item label="当前可用总积分">
                      <el-input
                          readonly
                          v-model="MemberInformation.availPointAll"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="消费当前可用积分">
                      <el-input
                          readonly
                          v-model="MemberInformation.availPoint"
                      ></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="GF当前可用积分">
                      <el-input
                          readonly
                          v-model="MemberInformation.gfAvailPoint"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="待取消积分">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.loseEfficacyPoints"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="GF待取消积分">
                      <el-input
                          readonly
                          v-model="MemberInformation.gfLoseEfficacyPoints"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="今年累计积分">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.currYearPoints"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="去年累积积分">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.preYearPoints"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="总累积积分">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.allPoints"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="待生效积分">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.pendingPoints"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="今年已使用积分">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.currExchangePoints"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="去年已使用积分">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.prevExchangePoints"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="消费信息" name="fourth">
            <div style="padding: 0 50px">
              <el-form
                  readonly
                  size="small"
                  label-width="150px"
                  :label-position="labelPosition"
                  :model="MemberInformation"
              >
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="今年消费额">
                      <el-input
                          readonly
                          v-model="MemberInformation.currYearAmount"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="平均客单价">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.avgSheetAmt"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="今年消费次数合计">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.currYearSaleTimes"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Top1客单价">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.sheetTopAmt1"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="今年目标消费额">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.currTargetAmt"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Top2客单价">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.sheetTopAmt2"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="今年目标消费次数">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.currTargetSaleTimes"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Top3客单价">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.sheetTopAmt3"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="VIP消费行为标签">
                      <el-input
                          readonly
                          v-model="MemberInformation.saleTagName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="平均折扣">
                      <el-input
                          readonly
                          style="width: 100%"
                          v-model="MemberInformation.avgDiscount"
                      ></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item>
                      <el-checkbox
                          name="type"
                          disabled
                          label="是否退换货高频"
                          v-model="MemberInformation.isHighRB"
                      ></el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-checkbox
                          name="type"
                          disabled
                          v-model="MemberInformation.repurchaseWarning"
                          label="开源复购预警"
                          οnclick="return false"
                      ></el-checkbox>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最近购买日">
                      <el-date-picker
                          style="width: 100%"
                          v-model="MemberInformation.lastSaleDate"
                          type="date"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="购买数量合计">
                      <el-input
                          readonly
                          v-model="MemberInformation.saleAQty"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最近购买金额">
                      <el-input
                          readonly
                          v-model="MemberInformation.lastSaleAmt"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最近365天消费额">
                      <el-input
                          readonly
                          v-model="MemberInformation.lastYearAmount"
                      ></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="去年消费额">
                      <el-input
                          readonly
                          v-model="MemberInformation.prevYearAmount"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最近12个月消费次数最多门店">
                      <el-input
                          readonly
                          v-model="MemberInformation.yearMaxSaleOrgList"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="去年消费次数合计">
                      <el-input
                          readonly
                          v-model="MemberInformation.prevYearSaleTimes"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="今年维护店消费次数">
                      <el-input
                          readonly
                          v-model="MemberInformation.currYearServSaleTimes"
                      ></el-input>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="购买金额合计">
                      <el-input
                          readonly
                          v-model="MemberInformation.saleAAmount"
                      ></el-input>
                    </el-form-item>
                  </el-col>


                  <el-col :span="12">
                    <el-form-item label="升级后累积消费">
                      <el-input
                          readonly
                          v-model="MemberInformation.lastLvlAmount"
                      ></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="尺码信息" name="five">
            <div style="padding: 0 50px">
              <el-form
                  readonly
                  size="small"
                  label-width="100px"
                  :label-position="labelPosition"
                  :model="MemberInformation"
              >
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="身高">
                      <el-input
                          readonly
                          v-model="MemberInformation.heightName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="体重">
                      <el-input
                          readonly
                          v-model="MemberInformation.weightName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="上衣尺码">
                      <el-input
                          readonly
                          v-model="MemberInformation.topSize"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="下装尺码">
                      <el-input
                          readonly
                          v-model="MemberInformation.bottomSize"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="裙装尺码">
                      <el-input
                          readonly
                          v-model="MemberInformation.skirtSize"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="鞋码">
                      <el-input
                          readonly
                          v-model="MemberInformation.shoeSize"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="行为偏好" name="six">
            <div style="padding: 0 50px">
              <el-form
                  readonly
                  size="small"
                  label-width="140px"
                  :label-position="labelPosition"
                  :model="MemberInformation"
              >
                <el-row :gutter="200">
                  <el-col :span="12">
                    <el-form-item label="客户性格类型: 交流">
                      <el-input
                          readonly
                          v-model="MemberInformation.talkativeName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="客户性格类型: 买单">
                      <el-input
                          readonly
                          v-model="MemberInformation.opionion2Name"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="客户性格类型: 决策">
                      <el-input
                          readonly
                          v-model="MemberInformation.opionionName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="颜色偏好">
                      <el-input
                          readonly
                          v-model="MemberInformation.colorPreference"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="特殊产品偏好">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.ProductHobby"
                        ></textarea>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="客户着衣风格">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.DressStyle"
                        ></textarea>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="到店时间偏好">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.ArrivalTime"
                        ></textarea>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="奢侈品信息获取渠道">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            v-model="checkBoxText.AccessToLuxuryInformation"
                            class="textareaClass"
                        ></textarea>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="兴趣爱好">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.Hobby"
                        ></textarea>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="邀约敏感点">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.InvitationSensitivePoints"
                        ></textarea>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="日常奢侈品购买渠道">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.LuxuryPurchaseChannels"
                        ></textarea>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="经常穿着品牌">
                        <textarea
                            name=""
                            id=""
                            rows="6"
                            readonly
                            class="textareaClass"
                            v-model="checkBoxText.OftenWearBrand"
                        ></textarea>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="不良销售记录">
                      <el-input
                          readonly
                          v-model="MemberInformation.badRecord"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="注意点">
                      <el-input
                          readonly
                          v-model="MemberInformation.arriveShopTimeNotes"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="子女情况">
                      <el-input
                          readonly
                          v-model="MemberInformation.hasChild"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="最小子女出生年">
                      <el-input
                          readonly
                          v-model="MemberInformation.childBirthYear"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="宗教信仰">
                      <el-input
                          readonly
                          v-model="MemberInformation.religiousName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="六小类客户群体">
                      <el-input
                          readonly
                          v-model="MemberInformation.sixTypeName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="四大客户群体">
                      <el-input
                          readonly
                          v-model="MemberInformation.custGroupName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="经常穿着品牌备注">
                      <el-input
                          readonly
                          v-model="MemberInformation.preferBrandNotes"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-dialog>

  </div>
</template>

<script>
import { definedQueryListApi } from "@/api/region";
import { shopQueryRegionApi } from "@/api/marketing";
import { regionalQuery } from "@/api/huiyuanyy"; //区域
import { queryLSelectApi } from "@/api/user"; // 会员等级接口
import { getcpyNo } from "@/utils/auth";
import {
  getMemberReportFormList,
  provinceApi,
  cityApi,
  getMemberReportFormStatistics,
  reportFormList,
  memberReportForm,
  ReportgetdisplayfiledApi,
} from "@/api/reportForm";
import { queryRmfSelectApi } from "@/api/user";
import {GetDetail} from "@/api/viewMemberModule";
import {mapState} from "vuex";

export default {
  name: "centre",
  data() {
    return {
      Selectdisplayitem: [],
      Selectdisplayiteme: [],
      SelectdisplayitemDialog: false,
      customerInfoVisible: false,
      downloadShow: false, //下载列表弹窗
      exportShow: false,
      loading: true,
      provinceData: [], //省份
      cityData: [], //城市
      outletVisible: false, //门店弹窗
      StoreSelectionList: [], //选择门店数据
      radioxz: "",
      conditionDialog: false,
      dateValue: [], //注册日期
      protectionDate: [], //保级日期
      dateValue1: [], //创建日期
      // dateValue2: [], //创建日期
      dateValue3: [], //创建日期
      dateValue4: [], //创建日期
      dateValue5: [], //创建日期
      dateValue6: [], //生日所在月份
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      tableData: [],
      queryInfo: {
        regionKind: "",
        pageNum: 1, //页码
        pageSize: 50, //每页数量
        displayFiled: [],
        cmn: "", //姓名,卡号,手机
        RegistDateStart: "", //注册开始时间
        RegistDateEnd: "", //注册结束时间
        lvlExpireDateStart: "", //保级开始时间
        lvlExpireDateEnd: "", //保级结束时间
        CreateTimeStart: "", //创建时间开始
        CreateTimeEnd: "", //创建时间结束
        regionIds: [], //地区
        LevelID: [], //等级
        cardNo: "", //卡号
        userName: "", //姓名
        Mobile: "", //电话
        shopIds: [], //维护店
        ServiceEmpName: "", //维护人
        provinceName: "", //省
        cityName: "", //市
        BirthdayStart: "", //生日
        BirthdayEnd: "", //生日
        LastSaleDateStart: "", //最近购买日
        LastSaleDateEnd: "", //最近购买日
        tagIds: [], //会员TAG
        activityLvlTagID: [], //会员活跃度
        isMillVIP: "", //是否商城VIP,0否,1是
        isServiceEmp: "", //非分配维护人,0否,1是
        CurrYearAmountMin: "", //今年消费额
        CurrYearAmountMax: "", //今年消费额
        PrevYearAmountMin: "", //去年消费金额
        PrevYearAmountMax: "", //去年消费金额
        LastYearAmountMin: "", //最近一年消费额
        LastYearAmountMax: "", //最近一年消费额
        SheetTopAmt1Min: "", //TOP1客单价
        SheetTopAmt1Max: "", //TOP1客单价
        SheetTopAmt2Min: "", //TOP2客单价
        SheetTopAmt2Max: "", //TOP2客单价
        SheetTopAmt3Min: "", //TOP3客单价
        SheetTopAmt3Max: "", //TOP3客单价
        MonetaryMin: "", //M期间消费金额
        MonetaryMax: "", //M期间消费金额
        FrequencyMin: "", //F期间消费次数
        FrequencyMax: "", //F期间消费次数
        TMaxMoneyMin: "", //T期间最大单
        TMaxMoneyMax: "", //T期间最大单
        saleTagID: "", //RMF标签
        industryID: "", //行业
        hasRelegation: "", //当前是否已保级
        canDegradeLvl: "", //当前可能降级级别
        CurrAvailPointMin: "", //当前可用积分
        CurrAvailPointMax: "", //当前可用积分
        PreYearPointsMin: "", //去年累计积分
        PreYearPointsMax: "", //去年累计积分
        CurrYearPointsMin: "", //今年累计积分
        CurrYearPointsMax: "", //今年累计积分
        FirstVipDateStart: "", //升级为VIC的时间
        FirstVipDateEnd: "", //升级为VIC的时间
        updateLvlDateStart: "", //最新升级日期
        updateLvlDateEnd: "", //最新升级日期
        UpdateLvlRegionIds: [], //升级为VIC的区域
        PrevYearSaleTimesMin: "", //去年消费次数
        PrevYearSaleTimesMax: "", //去年消费次数
        CurrYearSaleTimesMin: "", //今年消费次数
        CurrYearSaleTimesMax: "", //今年消费次数
        AvgSheetAmtMin: "", //平均客单价
        AvgSheetAmtMax: "", //平均客单价
        AvgDiscountMin: "", //平均折扣
        AvgDiscountMax: "", //平均折扣
        UpdateLvlOrgIds: [],
        lastLvlOrgIds: [],
        birthMonthStart: "",
        birthMonthEnd: "",
        birthDateStart: "",
        birthDateEnd: "",
        ageMin: "",
        ageMax: "",
      }, //列表页搜索数据
      bodyStyle: {
        padding: "0px",
      },
      StoreSelectLength: 0,
      StoredataArray: [],
      shopId: [],
      defaultProps: {
        children: "chlidren",
        label: "lable",
      },
      flag: 0,
      checkbooksData: [], //会员等级
      Regioncax: [], //区域
      jurisdiction: {
        search: false,
        export: false,
      },
      statisticsData: {}, //统计数据
      total: 0, //列表总条数
      lock: false,
      memberTagList: [],
      activityLevelList: [],
      ServiceOrgName: "", //维护店
      FirstVipOrgName: "", //升级为VIC的机构
      lastLvlOrgName: "",
      downloadData: [],
      //
      formThead: [],
      key: "",
      ID1: "",
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      days: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      levelRmfList: [],
      definedData: [],
      expiredFlag: false, //该会员是否失效
      busskind: '', //涉及业务
      checkBoxText: {
        activityLevel: "", //会员活跃度
        MemberTag: "", //会员tag
        ProductHobby: "", //特殊产品爱好
        ArrivalTime: "", //到店时间
        Hobby: "", //兴趣爱好
        LuxuryPurchaseChannels: "", //奢侈品购买渠道
        DressStyle: "", //衣着风格
        AccessToLuxuryInformation: "", //奢侈品信息获取渠道
        InvitationSensitivePoints: "", //邀约敏感点
        OftenWearBrand: "", //经常穿着品牌
        contactInfo: "", //联系方式添加情况
      },
      activeName: "first",
      labelPosition: "left",
    };
  },
  computed: {
    ...mapState({
      MemberInformation: (state) => state.user.MemberInformation, //会员基本信息
    }),
    onLoading() {
      return this.loading || this.tableData.length >= this.total;
    },
  },
  created() {
    queryRmfSelectApi({ defineKindID: -1 }).then(
      (res) => (this.levelRmfList = res.data)
    );
    let arrDkDs = [13, 11,-2];
    definedQueryListApi({ defineKindIDs: arrDkDs.join(",") }).then((res) => {
      this.definedData = res.data["11"] || []; // 行业
      this.memberTagList = res.data["13"] || []; // 会员TAG
      this.activityLevelList = res.data["-2"] || []; // 会员活跃度
    });
    let MemberReportForm = JSON.parse(localStorage.getItem("MemberReportForm"));
    this.Reportgetdisplayfiled();

    this.getProvince();
    this.memberReportFormStatistics();
    this.regioNalinformation();
    queryLSelectApi({ cpyNO: getcpyNo() }).then((res) => {
      this.checkbooksData = res.data;
    });
    this.ShopqueryRegionList();
    for (let i = 0; i < MemberReportForm.length; i++) {
      if (MemberReportForm[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (MemberReportForm[i].menuName == "导出") {
        this.jurisdiction.export = true;
        continue;
      }
    }
  },

  methods: {
    // 选择完成
    Selectfinish() {
      // this.key = this.key + 1
      this.queryInfo.displayFiled = this.ID1;
      this.tableData = [];
      this.queryInfo.pageNum = 1;
      this.tableList();
      this.loading = true;
      this.formThead = this.Selectdisplayitem.filter(
        (i) => this.ID1.indexOf(i.ID) >= 0
      );
      this.key = this.key + 1;
      this.SelectdisplayitemDialog = false;
    },
    // 恢复默认选项
    Restoredefault() {
      this.Selectdisplayiteme = [];
      this.Reportgetdisplayfiled();
      // this.queryInfo.displayFiled = this.ID1;
      this.tableData = [];
      this.queryInfo.pageNum = 1;
      // this.tableList()
      this.loading = true;
      this.$message.success("恢复默认选项成功!");
      this.SelectdisplayitemDialog = false;
    },
    // 显示项checkbox点击获值
    handleCheckedCitiesChange(val) {
      // this.formThead = this.Selectdisplayitem.filter(
      //   (i) => val.indexOf(i.ID) >= 0
      // );
      // this.key = this.key + 1
      this.ID1 = val;
    },
    // 获取显示项
    Reportgetdisplayfiled() {
      ReportgetdisplayfiledApi({ reportId: 1000 }).then((res) => {
        if (res.success == true) {
          this.formThead = [];
          this.key = this.key + 1;
          this.Selectdisplayitem = res.data;
          // 判断是否默认选项
          this.Selectdisplayitem.forEach((item) => {
            if (item.IsDefault == true) {
              this.Selectdisplayiteme.push(item.ID);
              this.ID1 = this.Selectdisplayiteme;
              this.queryInfo.displayFiled = this.Selectdisplayiteme;
              this.formThead.push(item);
            }
          });
          this.tableList();
        }
      });
    },
    //获取下载列表数据
    getDownladList() {
      reportFormList({
        groupName: "会员",
      }).then((response) => {
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    //每三位数字加，
    toThousands(num) {
      num = num + "";
      return num.replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
      });
    },
    //导出
    Export() {
      let data = {
        regionKind: this.queryInfo.regionKind,
        cmn: this.queryInfo.cmn,
        displayFiled: this.queryInfo.displayFiled,
        RegistDateStart: this.queryInfo.RegistDateStart,
        RegistDateEnd: this.queryInfo.RegistDateEnd,
        lvlExpireDateStart: this.queryInfo.lvlExpireDateStart,
        lvlExpireDateEnd: this.queryInfo.lvlExpireDateEnd,
        CreateTimeStart: this.queryInfo.CreateTimeStart,
        CreateTimeEnd: this.queryInfo.CreateTimeEnd,
        regionIds: this.queryInfo.regionIds,
        LevelID: this.queryInfo.LevelID,
        cardNo: this.queryInfo.cardNo,
        userName: this.queryInfo.userName,
        Mobile: this.queryInfo.Mobile,
        shopIds: this.queryInfo.shopIds,
        ServiceEmpNam: this.queryInfo.ServiceEmpNam,
        provinceName: this.queryInfo.provinceName,
        cityName: this.queryInfo.cityName,
        BirthdayStart: this.queryInfo.BirthdayStart,
        BirthdayEnd: this.queryInfo.BirthdayEnd,
        LastSaleDateStart: this.queryInfo.LastSaleDateStart,
        LastSaleDateEnd: this.queryInfo.LastSaleDateEnd,
        tagIds: this.queryInfo.tagIds,
        activityLvlTagID: this.queryInfo.activityLvlTagID,
        isMillVIP: this.queryInfo.isMillVIP,
        isServiceEmp: this.queryInfo.isServiceEmp,
        CurrYearAmountMin: this.queryInfo.CurrYearAmountMin,
        CurrYearAmountMax: this.queryInfo.CurrYearAmountMax,
        PrevYearAmountMin: this.queryInfo.PrevYearAmountMin,
        PrevYearAmountMax: this.queryInfo.PrevYearAmountMax,
        LastYearAmountMin: this.queryInfo.LastYearAmountMin,
        LastYearAmountMax: this.queryInfo.LastYearAmountMax,
        SheetTopAmt1Min: this.queryInfo.SheetTopAmt1Min,
        SheetTopAmt1Max: this.queryInfo.SheetTopAmt1Max,
        SheetTopAmt2Min: this.queryInfo.SheetTopAmt2Min,
        SheetTopAmt2Max: this.queryInfo.SheetTopAmt2Max,
        SheetTopAmt3Min: this.queryInfo.SheetTopAmt3Min,
        SheetTopAmt3Max: this.queryInfo.SheetTopAmt3Max,
        MonetaryMin: this.queryInfo.MonetaryMin,
        MonetaryMax: this.queryInfo.MonetaryMax,
        FrequencyMin: this.queryInfo.FrequencyMin,
        FrequencyMax: this.queryInfo.FrequencyMax,
        TMaxMoneyMin: this.queryInfo.TMaxMoneyMin,
        TMaxMoneyMax: this.queryInfo.TMaxMoneyMax,
        saleTagID: this.queryInfo.saleTagID, //RMF标签
        industryID: this.queryInfo.industryID, //行业
        hasRelegation: this.queryInfo.hasRelegation,
        canDegradeLvl: this.queryInfo.canDegradeLvl,
        CurrAvailPointMin: this.queryInfo.CurrAvailPointMin,
        CurrAvailPointMax: this.queryInfo.CurrAvailPointMax,
        PreYearPointsMin: this.queryInfo.PreYearPointsMin,
        PreYearPointsMax: this.queryInfo.PreYearPointsMax,
        CurrYearPointsMin: this.queryInfo.CurrYearPointsMin,
        CurrYearPointsMax: this.queryInfo.CurrYearPointsMax,
        FirstVipDateStart: this.queryInfo.FirstVipDateStart,
        FirstVipDateEnd: this.queryInfo.FirstVipDateEnd,
        updateLvlDateStart: this.queryInfo.updateLvlDateStart, //最新升级日期
        updateLvlDateEnd: this.queryInfo.updateLvlDateEnd, //最新升级日期
        UpdateLvlRegionIds: this.queryInfo.UpdateLvlRegionIds,
        PrevYearSaleTimesMin: this.queryInfo.PrevYearSaleTimesMin,
        PrevYearSaleTimesMax: this.queryInfo.PrevYearSaleTimesMax,
        CurrYearSaleTimesMin: this.queryInfo.CurrYearSaleTimesMin,
        CurrYearSaleTimesMax: this.queryInfo.CurrYearSaleTimesMax,
        AvgSheetAmtMin: this.queryInfo.AvgSheetAmtMin,
        AvgSheetAmtMax: this.queryInfo.AvgSheetAmtMax,
        AvgDiscountMin: this.queryInfo.AvgDiscountMin,
        AvgDiscountMax: this.queryInfo.AvgDiscountMax,
        UpdateLvlOrgIds: this.queryInfo.UpdateLvlOrgIds,
        lastLvlOrgIds: this.queryInfo.lastLvlOrgIds,
        birthMonthStart: this.queryInfo.birthMonthStart,
        birthMonthEnd: this.queryInfo.birthMonthEnd,
        birthDateStart: this.queryInfo.birthDateStart,
        birthDateEnd: this.queryInfo.birthDateEnd,
        ageMin: this.queryInfo.ageMin,
        ageMax: this.queryInfo.ageMax,
        ServiceEmpName: this.queryInfo.ServiceEmpName,
      }; //列表页搜索数据
      memberReportForm(data).then(() => {
        this.exportShow = false;
        this.$message.success("导出成功请在下载列表查看");
      });
    },
    //清除普通筛选条件
    eliminate() {
      this.queryInfo = {
        regionKind: "",
        pageNum: 1, //页码
        pageSize: 50, //每页数量
        displayFiled: this.queryInfo.displayFiled,
        cmn: "", //姓名,卡号,手机
        RegistDateStart: "", //注册开始时间
        RegistDateEnd: "", //注册结束时间
        lvlExpireDateStart: "", //保级开始时间
        lvlExpireDateEnd: "", //保级结束时间
        CreateTimeStart: "", //创建时间开始
        CreateTimeEnd: "", //创建时间结束
        regionIds: [], //地区
        LevelID: [], //等级
        cardNo: "", //卡号
        userName: "", //姓名
        Mobile: "", //电话
        shopIds: [], //维护店
        ServiceEmpName: "", //维护人
        provinceName: "", //省
        cityName: "", //市
        BirthdayStart: "", //生日
        BirthdayEnd: "", //生日
        LastSaleDateStart: "", //最近购买日
        LastSaleDateEnd: "", //最近购买日
        tagIds: [], //会员TAG
        activityLvlTagID: [], //会员活跃度
        isMillVIP: "", //是否商城VIP,0否,1是
        isServiceEmp: "", //非分配维护人,0否,1是
        CurrYearAmountMin: "", //今年消费额
        CurrYearAmountMax: "", //今年消费额
        PrevYearAmountMin: "", //去年消费金额
        PrevYearAmountMax: "", //去年消费金额
        LastYearAmountMin: "", //最近一年消费额
        LastYearAmountMax: "", //最近一年消费额
        SheetTopAmt1Min: "", //TOP1客单价
        SheetTopAmt1Max: "", //TOP1客单价
        SheetTopAmt2Min: "", //TOP2客单价
        SheetTopAmt2Max: "", //TOP2客单价
        SheetTopAmt3Min: "", //TOP3客单价
        SheetTopAmt3Max: "", //TOP3客单价
        MonetaryMin: "", //M期间消费金额
        MonetaryMax: "", //M期间消费金额
        FrequencyMin: "", //F期间消费次数
        FrequencyMax: "", //F期间消费次数
        TMaxMoneyMin: "", //T期间最大单
        TMaxMoneyMax: "", //T期间最大单
        saleTagID: "",
        industryID: "", //行业
        hasRelegation: "", //当前是否已保级
        canDegradeLvl: "", //当前可能降级级别
        CurrAvailPointMin: "", //当前可用积分
        CurrAvailPointMax: "", //当前可用积分
        PreYearPointsMin: "", //去年累计积分
        PreYearPointsMax: "", //去年累计积分
        CurrYearPointsMin: "", //今年累计积分
        CurrYearPointsMax: "", //今年累计积分
        FirstVipDateStart: "", //升级为VIC的时间
        FirstVipDateEnd: "", //升级为VIC的时间
        updateLvlDateStart: "", //最新升级日期
        updateLvlDateEnd: "", //最新升级日期
        UpdateLvlRegionIds: [], //升级为VIC的区域
        PrevYearSaleTimesMin: "", //去年消费次数
        PrevYearSaleTimesMax: "", //去年消费次数
        CurrYearSaleTimesMin: "", //今年消费次数
        CurrYearSaleTimesMax: "", //今年消费次数
        AvgSheetAmtMin: "", //平均客单价
        AvgSheetAmtMax: "", //平均客单价
        AvgDiscountMin: "", //平均折扣
        AvgDiscountMax: "", //平均折扣
        UpdateLvlOrgIds: [],
        lastLvlOrgIds: [],
        birthMonthStart: "",
        birthMonthEnd: "",
        birthDateStart: "",
        birthDateEnd: "",
        ageMin: "",
        ageMax: "",
      }; //列表页搜索数据
      this.dateValue = [];
      this.protectionDate = [];
      this.dateValue1 = [];
      // this.dateValue2 = [];
      this.dateValue3 = [];
      this.dateValue4 = [];
      this.dateValue5 = [];

      this.ServiceOrgName = ""; //维护店
      this.FirstVipOrgName = ""; //升级为VIC的机构
      this.lastLvlOrgName = "";
      this.queryInfo.pageNum = 1;
      this.loading = true;
      this.tableData = [];
      this.tableList();
      this.memberReportFormStatistics();
    },
    //表格触底加载
    load() {
      this.loading = true;
      this.queryInfo.pageNum += 1;
      this.tableList();
    },
    //列表搜索
    search() {
      if (this.lock) {
        return;
      }
      this.lock = true;
      //注册日期
      if (this.dateValue && this.dateValue.length > 0) {
        this.queryInfo.RegistDateStart = this.renderTime(
          this.dateValue[0]
        ).substring(0, 10);
        this.queryInfo.RegistDateEnd = this.renderTime(
          this.dateValue[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.RegistDateStart = "";
        this.queryInfo.RegistDateEnd = "";
      }
      // 保级日期
      if (this.protectionDate && this.protectionDate.length > 0) {
        this.queryInfo.lvlExpireDateStart = this.renderTime(
          this.protectionDate[0]
        ).substring(0, 10);
        this.queryInfo.lvlExpireDateEnd = this.renderTime(
          this.protectionDate[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.lvlExpireDateStart = "";
        this.queryInfo.lvlExpireDateEnd = "";
      }

      //创建日期
      if (this.dateValue1 && this.dateValue1.length > 0) {
        this.queryInfo.CreateTimeStart = this.renderTime(
          this.dateValue1[0]
        ).substring(0, 10);
        this.queryInfo.CreateTimeEnd = this.renderTime(
          this.dateValue1[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.CreateTimeStart = "";
        this.queryInfo.CreateTimeEnd = "";
      }

      // //生日
      // if (this.dateValue2 && this.dateValue2.length > 0) {
      //   this.queryInfo.BirthdayStart = this.renderTime(this.dateValue2[0]).substring(0, 10);
      //   this.queryInfo.BirthdayEnd = this.renderTime(this.dateValue2[1]).substring(0, 10);
      // } else {
      //   this.queryInfo.BirthdayStart = "";
      //   this.queryInfo.BirthdayEnd = "";
      // }
      //最近购买日
      if (this.dateValue3 && this.dateValue3.length > 0) {
        this.queryInfo.LastSaleDateStart = this.renderTime(
          this.dateValue3[0]
        ).substring(0, 10);
        this.queryInfo.LastSaleDateEnd = this.renderTime(
          this.dateValue3[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.LastSaleDateStart = "";
        this.queryInfo.LastSaleDateEnd = "";
      }
      //升级为VIC的时间
      if (this.dateValue4 && this.dateValue4.length > 0) {
        this.queryInfo.FirstVipDateStart = this.renderTime(
          this.dateValue4[0]
        ).substring(0, 10);
        this.queryInfo.FirstVipDateEnd = this.renderTime(
          this.dateValue4[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.FirstVipDateStart = "";
        this.queryInfo.FirstVipDateEnd = "";
      }

      //升级为VIC的时间
      if (this.dateValue5 && this.dateValue5.length > 0) {
        this.queryInfo.updateLvlDateStart = this.renderTime(
          this.dateValue5[0]
        ).substring(0, 10);
        this.queryInfo.updateLvlDateEnd = this.renderTime(
          this.dateValue5[1]
        ).substring(0, 10);
      } else {
        this.queryInfo.updateLvlDateStart = "";
        this.queryInfo.updateLvlDateEnd = "";
      }

      this.loading = true;
      this.tableData = [];
      this.queryInfo.pageNum = 1;
      this.tableList();
      this.memberReportFormStatistics();
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    //区域渲染数据
    async regioNalinformation() {
      const res = await regionalQuery({ regionID: "" });
      this.Regioncax = res.data;
      // this.queryInfoList = res.data;
      // this.shopafter = res.data;
    },
    //统计
    memberReportFormStatistics() {
      let data = {
        regionKind: this.queryInfo.regionKind,
        cmn: this.queryInfo.cmn,
        RegistDateStart: this.queryInfo.RegistDateStart,
        RegistDateEnd: this.queryInfo.RegistDateEnd,
        lvlExpireDateStart: this.queryInfo.lvlExpireDateStart,
        lvlExpireDateEnd: this.queryInfo.lvlExpireDateEnd,
        CreateTimeStart: this.queryInfo.CreateTimeStart,
        CreateTimeEnd: this.queryInfo.CreateTimeEnd,
        regionIds: this.queryInfo.regionIds,
        LevelID: this.queryInfo.LevelID,
        cardNo: this.queryInfo.cardNo,
        userName: this.queryInfo.userName,
        Mobile: this.queryInfo.Mobile,
        shopIds: this.queryInfo.shopIds,
        ServiceEmpNam: this.queryInfo.ServiceEmpNam,
        provinceName: this.queryInfo.provinceName,
        cityName: this.queryInfo.cityName,
        BirthdayStart: this.queryInfo.BirthdayStart,
        BirthdayEnd: this.queryInfo.BirthdayEnd,
        LastSaleDateStart: this.queryInfo.LastSaleDateStart,
        LastSaleDateEnd: this.queryInfo.LastSaleDateEnd,
        tagIds: this.queryInfo.tagIds,
        activityLvlTagID: this.queryInfo.activityLvlTagID,
        isMillVIP: this.queryInfo.isMillVIP,
        isServiceEmp: this.queryInfo.isServiceEmp,
        CurrYearAmountMin: this.queryInfo.CurrYearAmountMin,
        CurrYearAmountMax: this.queryInfo.CurrYearAmountMax,
        PrevYearAmountMin: this.queryInfo.PrevYearAmountMin,
        PrevYearAmountMax: this.queryInfo.PrevYearAmountMax,
        LastYearAmountMin: this.queryInfo.LastYearAmountMin,
        LastYearAmountMax: this.queryInfo.LastYearAmountMax,
        SheetTopAmt1Min: this.queryInfo.SheetTopAmt1Min,
        SheetTopAmt1Max: this.queryInfo.SheetTopAmt1Max,
        SheetTopAmt2Min: this.queryInfo.SheetTopAmt2Min,
        SheetTopAmt2Max: this.queryInfo.SheetTopAmt2Max,
        SheetTopAmt3Min: this.queryInfo.SheetTopAmt3Min,
        SheetTopAmt3Max: this.queryInfo.SheetTopAmt3Max,
        MonetaryMin: this.queryInfo.MonetaryMin,
        MonetaryMax: this.queryInfo.MonetaryMax,
        FrequencyMin: this.queryInfo.FrequencyMin,
        FrequencyMax: this.queryInfo.FrequencyMax,
        TMaxMoneyMin: this.queryInfo.TMaxMoneyMin,
        TMaxMoneyMax: this.queryInfo.TMaxMoneyMax,
        saleTagID: this.queryInfo.saleTagID,
        industryID: this.queryInfo.industryID,
        hasRelegation: this.queryInfo.hasRelegation,
        canDegradeLvl: this.queryInfo.canDegradeLvl,
        CurrAvailPointMin: this.queryInfo.CurrAvailPointMin,
        CurrAvailPointMax: this.queryInfo.CurrAvailPointMax,
        PreYearPointsMin: this.queryInfo.PreYearPointsMin,
        PreYearPointsMax: this.queryInfo.PreYearPointsMax,
        CurrYearPointsMin: this.queryInfo.CurrYearPointsMin,
        CurrYearPointsMax: this.queryInfo.CurrYearPointsMax,
        FirstVipDateStart: this.queryInfo.FirstVipDateStart,
        FirstVipDateEnd: this.queryInfo.FirstVipDateEnd,
        updateLvlDateStart: this.queryInfo.updateLvlDateStart, //最新升级日期
        updateLvlDateEnd: this.queryInfo.updateLvlDateEnd, //最新升级日期
        UpdateLvlRegionIds: this.queryInfo.UpdateLvlRegionIds,
        PrevYearSaleTimesMin: this.queryInfo.PrevYearSaleTimesMin,
        PrevYearSaleTimesMax: this.queryInfo.PrevYearSaleTimesMax,
        CurrYearSaleTimesMin: this.queryInfo.CurrYearSaleTimesMin,
        CurrYearSaleTimesMax: this.queryInfo.CurrYearSaleTimesMax,
        AvgSheetAmtMin: this.queryInfo.AvgSheetAmtMin,
        AvgSheetAmtMax: this.queryInfo.AvgSheetAmtMax,
        AvgDiscountMin: this.queryInfo.AvgDiscountMin,
        AvgDiscountMax: this.queryInfo.AvgDiscountMax,
        UpdateLvlOrgIds: this.queryInfo.UpdateLvlOrgIds,
        lastLvlOrgIds: this.queryInfo.lastLvlOrgIds,
        ServiceEmpName: this.queryInfo.ServiceEmpName,
        birthMonthStart: this.queryInfo.birthMonthStart,
        birthMonthEnd: this.queryInfo.birthMonthEnd,
        birthDateStart: this.queryInfo.birthDateStart,
        birthDateEnd: this.queryInfo.birthDateEnd,
        ageMin: this.queryInfo.ageMin,
        ageMax: this.queryInfo.ageMax,
      }; //列表页搜索数据

      getMemberReportFormStatistics(data).then((res) => {
        this.statisticsData = res.data;
      });
    },
    // 获取区域门店
    ShopqueryRegionList() {
      shopQueryRegionApi({ state: 1 }).then((res) => {
        let arr1 = [],
          arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            item.chlidren.forEach((item) => {
              item.ShopID = item.id;
            });
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 选择门店
    ComButtomStore() {
      //获取已选择的门店数据
      let listOfSomeStoresl = [];
      let listOfSomeStoreslStr = "";
      for (let index = 0; index < this.StoreSelectLength; index++) {
        let item = this.$refs.tree[index].getCheckedNodes();
        if (item.length == this.StoredataArray[index].chlidren.length + 1) {
          listOfSomeStoresl.push(...this.StoredataArray[index].chlidren);
        } else {
          listOfSomeStoresl.push(...item);
        }
      }
      listOfSomeStoresl.forEach((item) => {
        listOfSomeStoreslStr += `${item.lable}\n`;
      });
      // listOfSomeStoreslStr = listOfSomeStoreslStr.substring(
      //   0,
      //   listOfSomeStoreslStr.length - 2
      // );
      let shopId = []; //选中门店数据
      for (let i = 0; i < listOfSomeStoresl.length; i++) {
        shopId.push(listOfSomeStoresl[i].id);
      }

      if (this.flag == 1) {
        this.ServiceOrgName = listOfSomeStoreslStr;
        this.queryInfo.shopIds = shopId;
      } else if (this.flag == 3) {
        this.lastLvlOrgName = listOfSomeStoreslStr;
        this.queryInfo.lastLvlOrgIds = shopId;
      } else {
        this.FirstVipOrgName = listOfSomeStoreslStr;
        this.queryInfo.UpdateLvlOrgIds = shopId;
      }
      this.outletVisible = false;
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    //列表数据
    tableList() {
      getMemberReportFormList(this.queryInfo).then((res) => {
        if (res.success) {
          res.data.list.forEach((item) => {
            if (item.regionKind == 1) {
              item.Name = `▲ ${item.Name}`;
            }
            item.HasRelegation =
              item.HasRelegation == false
                ? "否"
                : item.HasRelegation == true
                ? "是"
                : "";
            item.LastSaleDate = this.renderTime(item.LastSaleDate);
            item.Birthday = this.renderTime(item.Birthday);
            item.RegistDate = this.renderTime(item.RegistDate);
            item.FirstVipDate = this.renderTime(item.FirstVipDate);
          });
        }
        this.tableData = this.tableData.concat(res.data.list);
        this.total = res.data.total;
        setTimeout(() => {
          this.loading = false;
          this.lock = false;
        }, 200);
      });
    },
    //获取省份列表
    getProvince() {
      provinceApi({
        countryID: "CN",
      }).then((res) => {
        this.provinceData = res.data;
      });
    },
    //省份选中
    provinceChange(value) {
      this.provinceValue = value;
      this.formLabelAlign.cityID = "";
      this.cityData = [];
      this.cityList(value);
    },
    // 城市
    cityList(stateID) {
      cityApi({ stateID: stateID }).then((res) => {
        this.cityData = res.data;
      });
    },
    //判断是否有先选择城市
    focus() {
      if (this.cityData.length < 1) {
        this.$message.info("请先选择省份");
      }
    },

    getCurrentRow(val) {
      // 获取选中数据   row表示选中这一行的数据，可以从里面提取所需要的值
      this.multipleSelection = val;
      localStorage.setItem("custID", val.CustID);
      if (this.multipleSelection == undefined)
        return this.$message.info("请选择数据,进行查看!");
      this.RGetDetail(val.CustID);
      this.customerInfoVisible=true;
    },

    RGetDetail(custID) {
      //会员基本信息
      let data = require("qs").stringify({
        //请求参数装换为formData类型
        custID: custID,
        cpyNo: getcpyNo,
      });
      GetDetail(data).then((res) => {
        if (res.success == true) {
          this.expiredFlag = res.data.state !== 0;
          res.data.gender =
              res.data.gender == 2 ? "男" : res.data.gender == 1 ? "女" : "未知";
          res.data.isMillVIP = res.data.isMillVIP == 1 ? true : false;
          res.data.custType = res.data.custType == 1 ? true : false;
          if (res.data.yearMaxSaleOrgList.length > 0) {
            let yearMaxSaleOrgList = "";
            res.data.yearMaxSaleOrgList.forEach((item, index) => {
              if (index >= 0 && index <= 2) {
                yearMaxSaleOrgList += item + ";";
              }
              if (index == 3) {
                yearMaxSaleOrgList += "...";
              }
            });
            res.data.yearMaxSaleOrgList = yearMaxSaleOrgList;
          } else {
            res.data.yearMaxSaleOrgList = "";
          }
          if (res.data.tBussindefineList.length > 0) {
            let busskind = "";
            res.data.tBussindefineList.forEach((item) => {

              busskind += item.bussnameCn + ";";
            });
            this.busskind = busskind;
          }
          for (const key in res.select) {
            res.select[key].forEach((item) => {
              //格式化textarea中的类型
              if (key == 10) {
                //顾客偏好产品定义
                this.checkBoxText.ProductHobby += item.description_CN + "\n";
              }
              if (key == 13) {
                //顾客标签（会员TAG）
                this.checkBoxText.MemberTag += item.description_CN + "\n";
              }
              if (key == -2) {
                //会员活跃度
                this.checkBoxText.activityLevel += item.description_CN + "\n";
              }
              if (key == 14) {
                //顾客到店时间偏好定义
                this.checkBoxText.ArrivalTime += item.description_CN + "\n";
              }
              if (key == 15) {
                //顾客着衣风格定义
                this.checkBoxText.DressStyle += item.description_CN + "\n";
              }
              if (key == 24) {
                //顾客邀约敏感点
                this.checkBoxText.InvitationSensitivePoints +=
                    item.description_CN + "\n";
              }
              if (key == 25) {
                //顾客兴趣爱好
                this.checkBoxText.Hobby += item.description_CN + "\n";
              }
              if (key == 26) {
                //顾客经常穿着品牌
                this.checkBoxText.OftenWearBrand += item.description_CN + "\n";
              }
              if (key == 27) {
                //顾客日常奢侈品购买渠道
                this.checkBoxText.LuxuryPurchaseChannels +=
                    item.description_CN + "\n";
              }
              if (key == 28) {
                //顾客奢侈品信息获取渠道
                this.checkBoxText.AccessToLuxuryInformation +=
                    item.description_CN + "\n";
              }
              if (key == 36) {
                //联系方式添加情况
                this.checkBoxText.contactInfo +=
                    item.description_CN + "\n";
              }
            });
          }
          this.$store.dispatch("user/UpGetMemberInformation", res.data); //保存基本会员信息到vuex
          localStorage.setItem("MemberInformation", JSON.stringify(res.data)); //保存基本会员信息到本地(防止用户刷新网页,清空vuex数据)
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#product {
  height: auto;
  padding-bottom: 50px;
}
/deep/.el-dialog__header {
  padding: 1.25rem 1.25rem 0.625rem;
  background-color: #d1cda5;
}
.dialog-footer {
  height: 40px;
  display: flex;
  justify-content: space-around;
}
/deep/.el-dialog__footer {
  height: 60px;
  text-align: center;
  background-color: #f2f2f2;
}
.buttonInfo {
  display: flex;
  justify-content: space-between;
  margin: 10px 100px;
}
.buttonInfo > div {
  display: flex;
  width: 35%;
}
.buttonInfo > div > div:first-child {
  margin-right: 10px;
}
.header {
  .header-text {
    width: 300px;
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
  .card-pagination {
    height: 50px;
  }
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
.xuan .el-button {
  color: #4d4d4d;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  .el-textarea__inner {
    // 取消拉伸样式
    resize: none;
  }
  .create {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .amend {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .examine {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
.dialogTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 50px;
}
.dialogTitle > span {
  font-size: 16px;
  font-weight: 700;
  color: #6c6937;
}
.ConponesName {
  text-decoration: underline;
  color: #a19b59;
}
.ConponesName:hover {
  cursor: pointer;
}

</style>
